<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <el-row class="mydoc">
      <el-col class="header" style="font-weight: 900">
        {{ $t('preprint.listTitle') }}
      </el-col>
      <el-col class="mybody">
        <!-- 搜索栏 -->
        <el-row style="margin-bottom: 20px">
          <el-form :inline="true" :model="searchForm" size="medium">
            <el-form-item :label="$t('preprint.searchKeywordLabel')">
              <el-input
                v-model="searchForm.keyword"
                :placeholder="$t('preprint.searchKeywordPlaceholder')"
                clearable
                style="width: 200px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('preprint.searchTypeLabel')">
              <el-select
                v-model="searchForm.preprintType"
                :placeholder="$t('preprint.searchTypePlaceholder')"
                clearable
                style="width: 150px"
              >
                <el-option :label="$t('preprint.typeAll')" value=""></el-option>
                <el-option :label="$t('preprint.typePhysiology')" value="生理实验"></el-option>
                <el-option :label="$t('preprint.typeAcoustics')" value="声学实验"></el-option>
                <el-option :label="$t('preprint.typePsychology')" value="心理实验"></el-option>
                <el-option :label="$t('preprint.typeNeuroscience')" value="神经科学"></el-option>
                <el-option :label="$t('preprint.typeModeling')" value="建模仿真"></el-option>
                <el-option :label="$t('preprint.typeTheory')" value="理论探索"></el-option>
                <el-option :label="$t('preprint.typeReview')" value="评述推介"></el-option>
                <el-option :label="$t('preprint.typeNews')" value="学术资讯"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="searchPreprints"
                style="background-color: #0a666b; border: none"
              >
                {{ $t('preprint.searchButton') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-row>

        <!-- 预印本卡片列表 -->
        <el-row>
          <el-col
            :xl="{ span: 24 }"
            :lg="{ span: 24 }"
            :md="{ span: 24 }"
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
          >
            <el-card
              v-for="(item, index) in preprintList"
              :key="index"
              shadow="hover"
              style="cursor: pointer; margin-bottom: 15px"
              class="card_shadow"
              @click.native="viewDetail(item.id)"
            >
              <div slot="header" class="clearfix" style="padding-top: 15px; padding-bottom: 15px">
                <span
                  class="new_title"
                  style="color: #006a71; font-weight: 900"
                >
                  {{ item.title }}
                </span>
                <el-tag
                  size="mini"
                  style="float: right; margin-left: 10px"
                  type="info"
                >
                  {{ item.preprintType }}
                </el-tag>
                <span
                  style="float: right; color: #909399; font-size: 12px; margin-right: 15px"
                >
                  编号: {{ item.preprintNumber }}
                </span>
              </div>
              <div>
                <div style="font-size: 14px">
                  <span style="color: #006a71; font-weight: 900">{{ $t('preprint.listAuthor') }}:</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {{ item.authors && item.authors.length > 0 ? item.authors.map((a) => a.authorName).join(', ') : item.submitterName }}
                </div>
                <div style="font-size: 14px; margin-top: 10px" class="exceed">
                  <span style="color: #006a71; font-weight: 900">{{ $t('preprint.listAbstract') }}:</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;{{ item.abstractText }}
                </div>
                <div style="font-size: 14px; margin-top: 10px" class="exceed">
                  <span style="color: #006a71; font-weight: 900">{{ $t('preprint.listKeywords') }}:</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;{{ item.keywords }}
                </div>
                <div style="font-size: 12px; margin-top: 10px; color: #909399">
                  <i class="el-icon-view"></i> {{ $t('preprint.detailView') }} {{ item.viewCount }}
                  &nbsp;&nbsp;
                  <i class="el-icon-download"></i> {{ $t('preprint.detailDownload') }} {{ item.downloadCount }}
                  &nbsp;&nbsp;
                  <i class="el-icon-chat-dot-round"></i> {{ $t('preprint.detailComment') }} {{ item.commentCount }}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {{ $t('preprint.listSubmitTime') }}: {{ item.submitTime }}
                </div>
              </div>
            </el-card>

            <!-- 分页 -->
            <br />
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import { getPreprintList } from '@/api/preprint'

export default {
  name: 'preprintList',
  data() {
    return {
      searchForm: {
        keyword: '',
        preprintType: ''
      },
      preprintList: [],
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0
    }
  },
  methods: {
    viewDetail(id) {
      this.$router.push({
        name: 'preprintDetail',
        query: { id: id }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadPreprintList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadPreprintList()
    },
    searchPreprints() {
      this.currentPage = 1
      this.loadPreprintList()
    },
    loadPreprintList() {
      getPreprintList({
        current: this.currentPage,
        size: this.pageSize,
        keyword: this.searchForm.keyword,
        preprintType: this.searchForm.preprintType
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.preprintList = res.data.result.records || []
          this.pageTotal = res.data.result.total || 0
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.loadListFailed'))
        }
      }).catch((err) => {
        console.error('加载预印本列表错误:', err)
        this.$message.error(this.$t('preprint.loadListFailed'))
      })
    }
  },
  mounted() {
    this.loadPreprintList()
  }
}
</script>

<style lang="scss" scoped>
.new_title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 70%;
}
.exceed {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card_shadow {
  box-shadow: 1px 1px 5px rgba(9, 99, 103, 0.5);
  -moz-box-shadow: 1px 1px 5px rgba(9, 99, 103, 0.5);
  -webkit-box-shadow: 1px 1px 5px rgba(9, 99, 103, 0.5);
}

.content {
  margin-top: 12px;
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      height: 1090px;
      padding: 20px;
      background-color: white;
      overflow: auto;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/preprint/preprintList.vue